import { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";

const Counter = ({ end, label }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    if (!inView) return;

    let start = 0;
    const final = parseInt(end.replace(/\D/g, ""));
    const duration = 700;
    const step = Math.max(Math.floor(duration / final), 20);

    const timer = setInterval(() => {
      start += 1;
      if (start >= final) {
        clearInterval(timer);
        setCount(end);
      } else {
        setCount(start);
      }
    }, step);

    return () => clearInterval(timer);
  }, [inView, end]);

  return (
    <div ref={ref}>
      <h2>
        {typeof count === "number" ? count : parseInt(end.replace(/\D/g, ""))}
        {end.replace(/\d/g, "")}
      </h2>
      <p>{label}</p>
    </div>
  );
};

export default Counter;